import send, { sendLottery, sendWsLottery } from 'service/index';

export const findNewEnums = (data: any) => {
    return sendWsLottery({
        method: 'POST',
        url: '/sys/sysLanguage/findEnums',
        data,
    });
};

// // 国家列表
// export const findCountryList = data => {
//     return sendWsLottery({
//         method: 'post',
//         url: `/official/sport/match/findLocationList`,
//         data,
//     });
// };

// 国家列表
export const findCountryList = data => {
    return sendWsLottery({
        method: 'post',
        url: `/official/sport/match/findList`,
        data,
    });
};

// 联盟列表
export const findLeagueList = data => {
    return sendWsLottery({
        method: 'post',
        url: `/official/sport/match/findLeagueList`,
        data,
    });
};

// 赛果列表
export const findResultPage = data => {
    return sendWsLottery({
        method: 'post',
        url: `/official/sport/match/findPage/${data?.page}/${data?.size}`,
        data,
    });
};

// 赛果详情
export const findResultDetail = params => {
    return sendWsLottery({
        method: 'get',
        url: `/official/sport/match/findById/${params?.id}`,
        params,
    });
};

// 大厅列表
export const findMatchList = (data, cancelExecutor?: (cancel: () => void) => void) => {
    return sendWsLottery(
        {
            method: 'post',
            url: `/official/sport/play/findMatchList`,
            data,
        },
        cancelExecutor
    );
};

// 比赛详情
export const findMatchDetail = (gid: string) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/sport/play/findMatchInfo/${gid}`,
    });
};

// 今日和早盘联盟
export const findLocationLeagueList = (data, cancelExecutor?: (cancel: () => void) => void) => {
    return sendWsLottery(
        {
            method: 'post',
            url: `/official/sport/match/findLocationLeagueList`,
            data,
        },
        cancelExecutor
    );
};

// 冠军列表
export const findOutrightLocationList = params => {
    return sendWsLottery({
        method: 'get',
        url: `/official/sport/matchChampion/findLocationList/${params?.sportType}`,
    });
};

// 冠军联赛列表
export const findOutrightLeagueList = params => {
    return sendWsLottery({
        method: 'get',
        url: `/official/sport/matchChampion/findLeagueList/${params?.sportType}/${params?.locationId}`,
    });
};

// 冠军详情
export const findOutrightInfo = params => {
    return sendWsLottery({
        method: 'get',
        url: `/official/sport/matchChampion/findInfo/${params?.gid}`,
    });
};

// 购物车数据刷新
export const findPlayOdds = data => {
    return sendWsLottery({
        method: 'post',
        url: `/official/sport/play/findPlayOdds`,
        data,
    });
};

// 详情页,右上角弹窗的比赛(具体某个赛程)
export const findSingleLeagueList = data => {
    return sendWsLottery({
        method: 'post',
        url: `/official/sport/play/findFullHalfList`,
        data,
    });
};

// 获取热门比赛
export const findHotList = (cancelExecutor?: (cancel: () => void) => void) => {
    return sendWsLottery(
        {
            method: 'get',
            url: `/official/sport/play/findHotList`,
        },
        cancelExecutor
    );
};

// 投注记录
export const findBetRecordByStatus = data => {
    return sendWsLottery({
        url: `/official/sport/bet/findBet`,
        method: 'post',
        data,
    });
};
export const findBetRecordAll = data => {
    return sendWsLottery({
        url: `/official/sport/bet/findAllBet`,
        method: 'post',
        data,
    });
};

// 确认提前结算
export const findEarlySettlementConfirm = data => {
    return sendWsLottery({
        url: `/official/sport/bet/checkInAdvanceSettle/${data.id}`,
        method: 'post',
        data,
    });
};
// 提前结算
export const findEarlySettlement = (data: { id: number; inAdvanceSettleMoney: number }) => {
    return sendWsLottery({
        // url: `/official/sport/bet/inAdvanceSettle/${data.id}`,
        url: `/official/sport/bet/inAdvanceSettle`,
        method: 'post',
        data,
    });
};

// 收藏列表
export const findFavoritesMatchList = data => {
    return sendWsLottery({
        method: 'post',
        url: `/official/sport/play/findFavoritesMatchList`,
        data,
    });
};

// 冠军收藏列表
export const findChampionFavoritesMatchList = data => {
    return sendWsLottery({
        method: 'post',
        url: `/official/sport/matchChampion/findFavoritesMatchList`,
        data,
    });
};

// 体育公告(滚动)
export const getSportNoticeTopList = (params: any) => {
    return send({
        url: `/official/sport/notice/findTop/${params.size}`,
        // url: `/content/contentNotice/findSportPage/1/11`,
        method: 'get',
    });
};

// 体育公告(所有)
export const getSportNoticeAllList = (params: any) => {
    return send({
        // url: `/content/contentNotice/findSportPage/${params.current}/${params.size}`,
        url: `/official/sport/notice/findPage/${params.current}/${params.size}`,
        method: 'get',
    });
};

// 体育设置
export const findSportConfig = () => {
    return send({
        url: `/official/sport/config/findSportConfig`,
        method: 'get',
    });
};

// 保存体育设置
export const setConfig = data => {
    return send({
        url: `/official/sport/config/setConfig`,
        method: 'POST',
        data,
    });
};
